import { render, staticRenderFns } from "./ShippingCheckpointForm.vue?vue&type=template&id=5800f330"
import script from "./ShippingCheckpointForm.vue?vue&type=script&lang=js"
export * from "./ShippingCheckpointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports